/**
* Overlapping Cards Animation JS
* -----------------------------------------------------------------------------
*
* All the JS for the Overlapping Cards Animation component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {parse} from 'postcss';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'overlapping-cards-animation',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const docStyle = getComputedStyle( document.documentElement );
      const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
      const navBottomHeight = docStyle.getPropertyValue( '--navbarBottomHeight' );
      const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
      // const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight ) + parseInt( navBottomHeight );
      const topOffset = parseInt( navHeight ) + parseInt( navBottomHeight ) + parseInt( adminbarHeight );

      if ( window.innerWidth > 768 ) {
        $( '.overlapping-cards-animation .card:not(.card--0)' ).each( function() {
          const lessHeight = $( this ).outerHeight();
          $( this ).css( 'margin-top', '-' + lessHeight + 'px' );
        } );

        const overlappingCards = gsap.utils.toArray( '.overlapping-cards-animation .card:not(.card--0)' );

        gsap.from( overlappingCards, {
          yPercent: 100,
          ease: 'none',
          stagger: 1,
          scrollTrigger: {
            trigger: '.overlapping-cards-animation .card',
            start: 'top top+=' + topOffset + 'px',
            pin: '.overlapping-cards-animation',
            scrub: 0,
            // markers: true,
            end: () => '+=' + ( document.querySelector( '.overlapping-cards-animation' ).offsetHeight * ( $( '.overlapping-cards-animation .card' ).length ) ),
          },
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'overlapping-cards-animation', COMPONENT );
} )( app );
